import { TechSector } from "./tech-sector";

const theme = {
    font: 'Frutiger,helvetica,roboto,arial,sans-serif',
    typography: {
        xs: '10px',
        sm: '13px',
        md: '18px',
        lg: '22px',
        xl: '26px',
    },
    colors: {
        primaryDark: '#09213a',
        primary: '#00569d',
        primaryLight: '#4d89ba',
        primaryLighter: '#a0d2f3',
        secondary: '#eb5b25',
        secondaryLight: '#f18c66',
        signal: '#FF3333',
        gray1: '#cccccc',
        gray2: '#bbbbbb',
        gray3: '#575756',
        gray4: '#a8a8a8',
        white: '#ffffff',
        black: '#000000',
        primary80: '#0e233dcc',
        primaryLightContrast: '#039FE3',
        darkBlue: '#21436f',
        darkBlue2: '#1d3f67',
        darkBlue3: '#18385d',
        darkBlue4: '#132f4e',
        darkBlue5: '#0f2640',
        tealDark: '#125f79',
        tealDarker: '#0f4561',
        lightGray: '#f1f1f1',
        mediumGray: '#e3e3e3',
        textDark: '#060606',
        sectors: {
            [TechSector.WATER]: ['#0f6cb5', '#0f6cb5'],
            [TechSector.HEATING]: ['#e41428', '#66bdcd'],
            [TechSector.WASTE_WATER]: ['#ebd900', '#ebd900'],
            [TechSector.FIRE_PROTECTION]: ['#741329', '#741329'],
        },
    },
    screens: {
        sm: '(min-width: 640px)',
        md: '(min-width: 768px)',
        lg: '(min-width: 1024px)',
    },
    zIndex: {
        base: 1,
        behind: -1,
        content: 2,
        dropdown: 100,
        overlay: 300,
        modal: 1000,
        popover: 3000,
        tooltip: 9000,
        notification: 9999,
        max: 10000,
    },
};

export default theme;